import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
import GUI from "lil-gui";
import { FontLoader } from "three/examples/jsm/loaders/FontLoader.js";
import { TextGeometry } from "three/examples/jsm/geometries/TextGeometry.js";

const createText = (text, font) => {
  if (textMesh) {
    scene.remove(textMesh);
    textMesh.geometry.dispose();
  }

  const textGeometry = new TextGeometry(text, {
    font,
    size: 0.5,
    depth: 0.2,
    curveSegments: 4,
    bevelEnabled: true,
    bevelThickness: 0.03,
    bevelSize: 0.02,
    bevelOffset: 0,
    bevelSegments: 5,
  });

  textGeometry.center();

  textMesh = new THREE.Mesh(textGeometry, material);
  scene.add(textMesh);
};

const gui = new GUI();
const params = {
  text: "Nadiia Bulmak",
  imageNumber: 3,
};

const canvas = document.querySelector("canvas.webgl");

const scene = new THREE.Scene();

const textureLoader = new THREE.TextureLoader();
const matcapTexture = textureLoader.load(
  `/textures/matcaps/${params.imageNumber}.png`,
);
matcapTexture.colorSpace = THREE.SRGBColorSpace;

const material = new THREE.MeshMatcapMaterial({ matcap: matcapTexture });

let textMesh;

const fontLoader = new FontLoader();
fontLoader.load("/fonts/helvetiker_regular.typeface.json", (font) => {
  createText(params.text, font);

  const torusGeometry = new THREE.TorusGeometry(0.3, 0.2, 20, 45);
  for (let i = 0; i < 100; i++) {
    const donut = new THREE.Mesh(torusGeometry, material);

    donut.position.set(
      25 * (Math.random() - 0.5),
      25 * (Math.random() - 0.5),
      25 * (Math.random() - 0.5),
    );

    donut.rotation.x = Math.random() * Math.PI;
    donut.rotation.y = Math.random() * Math.PI;

    const scale = Math.random() + 1;
    donut.scale.set(scale, scale, scale);

    scene.add(donut);
  }

  gui.add(params, "text").onChange((value) => {
    createText(value, font);
  });

  gui
    .add(params, "imageNumber")
    .min(1)
    .max(8)
    .step(1)
    .onChange((value) => {
      const newTexture = textureLoader.load(`/textures/matcaps/${value}.png`);

      newTexture.colorSpace = THREE.SRGBColorSpace;

      material.matcap = newTexture;
      material.needsUpdate = true;
    });
});

const sizes = {
  width: window.innerWidth,
  height: window.innerHeight,
};

window.addEventListener("resize", () => {
  sizes.width = window.innerWidth;
  sizes.height = window.innerHeight;

  camera.aspect = sizes.width / sizes.height;
  camera.updateProjectionMatrix();

  renderer.setSize(sizes.width, sizes.height);
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
});

const camera = new THREE.PerspectiveCamera(
  75,
  sizes.width / sizes.height,
  0.1,
  100,
);
camera.position.x = 1;
camera.position.y = 1;
camera.position.z = 2;
scene.add(camera);

const controls = new OrbitControls(camera, canvas);
controls.enableDamping = true;

const renderer = new THREE.WebGLRenderer({
  canvas: canvas,
});
renderer.setSize(sizes.width, sizes.height);
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

const clock = new THREE.Clock();

const tick = () => {
  const elapsedTime = clock.getElapsedTime();

  controls.update();

  renderer.render(scene, camera);

  window.requestAnimationFrame(tick);
};

tick();
